var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-wrapper modal-scroll" }, [
    _c("div", { staticClass: "modal_size md_size" }, [
      _c(
        "a",
        {
          staticClass: "ui_close",
          attrs: { href: "javascript:", type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
      ),
      _vm._v(" "),
      _c("dl", { staticClass: "modal_content" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("dd", { staticClass: "scroll_btm" }, [
          _c("div", { staticClass: "btn_modal_wrap topLine pc_only" }, [
            _c("div", { staticClass: "btn_right text-right" }, [
              _c(
                "a",
                {
                  staticClass: "btn_blue",
                  attrs: {
                    href: "javascript:",
                    title: _vm.$t("BUTTON.GLOBAL.OK")
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.OK")))]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "ellipsis" }, [
      _c("i", [_vm._v("Privacy Policy")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _c("div", { staticClass: "policy_con" }, [
        _vm._v("\n                    Effective: [2018.03.07]"),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          '\n                    Samsung Electronics Co., Ltd. (“Samsung,” “we,” “us,” “our”) knows how important privacy is to its customers and their employees and partners, and we strive to be clear about how we collect, use, disclose, transfer and store your information. This Privacy Policy provides an overview of our information practices with respect to personal information collected through Business to Business Services with commercial customers or other services that link or refer to this Privacy Policy (collectively, the "Business Services").'
        ),
        _c("br"),
        _vm._v(
          "\n                    It is important that you check back often for updates to the Privacy Policy. If we update the Privacy Policy we will let you know about changes we consider to be material by placing a notice on this website or related online services and/or by email. You can check the “effective date” posted at the top to see when the Privacy Policy was last updated.\n\n                    "
        ),
        _c("dl", [
          _c("dt", [_vm._v("What information do we collect about you?")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            We will collect various types of personal information in connection with the Business Services.\n                            "
            ),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "We will collect personal information that you provide, such as your name, address, e-mail address and contact details, job title and position, company, language, registration details, and any communications you send or deliver to us;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "We will collect data about your use of the Business Services, including the time and duration of your use; information stored in cookies that we have set on your device; and information about your device settings;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "We will collect information about the products and services you or your employer have bought or received and payment data and other information provided in connection with a transaction;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "We also may receive personal information about you from your employer or service provider or from publicly and commercially available sources (as permitted by law), which we may combine with other information we receive from or about you (as permitted by law, or otherwise with your separate consent)."
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("How do we use your information?")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            We may use information we collect for the following purposes:\n                            "
            ),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "to provide products and services that you (or your employer) requested and to register or authenticate you or your device;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "to respond to your questions or requests for information;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "to offer better and more customized products and services that take into account your company’s purchasing history and service record and other relevant information;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "subject to your separate consent where required by applicable law, to inform you about new products and services;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "for assessment and analysis of our market, customers, products, and services (including asking you for your opinions on our products and services and carrying out customer surveys);"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "to understand the way companies use the Business Services so that we can improve them and develop new products and services;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "to provide maintenance services and to maintain a sufficient level of security on the Business Services;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "to protect the rights, property, or safety of Samsung, or any of our respective affiliates, business partners, employees or customers, for example, in legal proceedings, internal investigations and investigations by competent authorities;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "otherwise with your separate consent where required by applicable law or as described to at the time your information is collected."
                )
              ])
            ]),
            _vm._v(
              "\n                            Samsung processes personal data for the purposes described above. Samsung’s legal basis to process personal data includes processing that is: necessary for the performance of the contract between you and Samsung (for example, to provide you with the Business Services and to identify and authenticate you so you may use certain Business Services); necessary to comply with legal requirements (for example, to comply with applicable accounting rules and to make mandatory disclosures to law enforcement); necessary for Samsung’s legitimate interests (for example, to manage our relationship with you and to improve the Business Services); and based on obtaining your separate consent (for example, to communicate with you about our products and services and provide you with marketing information), which may subsequently be withdrawn at any time by contacting us as specified in the How to Contact Us section of this Privacy Policy without affecting the lawfulness of processing based on consent before its withdrawal.\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("To whom do we disclose your information?")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            We may disclose your information internally within our business to the relevant teams, such as, without limitation the customer services team, the legal team, and where you have chosen to receive marketing messages, to the marketing teams. We do not disclose your information to third parties for their own independent marketing or business purposes without your consent. But we may share your information with the following entities:\n                            "
            ),
            _c("ul", [
              _c("li", [_vm._v("Samsung affiliates;")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "third parties when necessary to provide you with requested products and services. For example, we may disclose your payment data to financial institutions as appropriate to process transactions that you have requested;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "companies that provide services for or on behalf of us, such as companies that help us with the billing process;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "other parties: (i) to comply with the law or respond to compulsory legal process (such as a search warrant or other court order); (ii) to verify or enforce compliance with the policies governing our Business Services; (iii) to protect the rights, property, or safety of Samsung, or any of our respective affiliates, business partners, or customers; (iv) as part of a merger or transfer, or in the event of a bankruptcy;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "with other third parties when you request such sharing."
                )
              ])
            ]),
            _vm._v(
              "\n                            Submissions that you make to public areas of a website, mobile application, or other online service, such as bulletin boards may be viewable to other users of the Business Services. We do not control, and are not responsible for, how other users of the Business Services may use this information. For example, personal information that you submit in public areas could be collected and used by others to send you unsolicited messages or for other purposes.\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("What do we do to keep your information secure?")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            Your use or participation in the Business Services may involve transfer, storage and processing of your information outside of your country of residence, consistent with this policy. Such countries include, without limitation, the Republic of Korea, the United States of America and Japan. Please note that the data protection and other laws of countries to which your information may be transferred might not be as comprehensive as those in your country. We will take appropriate measures, in compliance with applicable law, to ensure that your personal information remains protected. Such measures include the use of Standard Contractual Clauses to safeguard the transfer of data outside of the EEA. For more information on the safeguards we take to ensure the lawful transfer of your data to countries outside of the EU, or to obtain a copy of the contractual agreements in place, please contact us at dataprotection@samsung.com.\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("Can you access your information?")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            You may have the right to request details about the information we collect about you, to request us to correct inaccuracies in that information, to request access to your information, to object to or request the restriction of processing, to request the erasure or portability of your information. Under the laws of some jurisdictions, we may decline to process requests that are unreasonably repetitive, require disproportionate technical effort, jeopardize the privacy of others, are extremely impractical, or for which access is not otherwise required by local law. If you would like to make a request to access your information, please contact our customer service department.\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n                        If you request deletion of personal information, you acknowledge that you may not be able to access or use the Business Services and that residual personal information may continue to reside in Samsung's records and archives for some time in compliance with applicable law, but Samsung will not use that information for commercial purposes. You understand that, despite your request for deletion, Samsung reserves the right to keep your personal information, or a relevant part of it, in line with our data retention policy and applicable laws, if Samsung has suspended, limited, or terminated your access to the website for violating the Samsung Terms of Use, when necessary to protect the rights, property, or safety of Samsung, or any of our respective affiliates, business partners, employees or customers.\n                    "
          )
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("How long do we keep your information?")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            We take appropriate steps to ensure that we retain information about you based on the following logic:\n                            "
            ),
            _c("ol", [
              _c("li", [
                _vm._v(
                  "at least the duration for which the information is used to provide you with a service;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "as required under law, a contract or with regard to our statutory obligations;"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "only for so long as is necessary for the purpose for which it was collected,"
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("Third-Party Links and Products on Our Services")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            Our Business Services may link to third-party websites and services that are outside our control. We are not responsible for the security or privacy of any information collected by websites or other services. You should exercise caution, and review the privacy statements applicable to the third-party websites and services you use.\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("Cookies, Beacons and Similar Technologies")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            We, as well as certain third parties that provide content, advertising, or other functionality on our Business Services, may use cookies, beacons, and other technologies in certain areas of our Business Services.\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("Cookies")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            Cookies are small files that store information on your device. They enable the entity that put the cookie on your device to recognize you across different websites, services, devices, and/or browsing sessions. Cookies serve many useful purposes. For example:\n                            "
            ),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Cookies can remember your sign-in credentials so you don’t have to enter those credentials each time you log on to a service."
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Cookies help us and third parties understand which parts of our Business Services are the most popular because they help us to see which pages and features visitors are accessing and how much time they are spending on the pages. By studying this kind of information, we are better able to adapt the Business Services and provide you with a better experience."
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Cookies help us and third parties understand which ads you have seen so that you don’t receive the same ad each time you access our Business Services."
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Cookies help us and third parties provide you with relevant content and advertising by collecting information about your use of our Business Services and other websites and apps."
                )
              ])
            ]),
            _vm._v(
              "\n                            When you use a web browser to access the Business Services, you can configure your browser to accept all cookies, reject all cookies, or notify you when a cookie is sent. Each browser is different, so check the “Help” menu of your browser to learn how to change your cookie preferences. The operating system of your device may contain additional controls for cookies."
            ),
            _c("br"),
            _vm._v(
              "\n                            Please note, however, that some Business Services may be designed to work using cookies and that disabling cookies may affect your ability to use those Business Services, or certain parts of them.\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("Other Local Storage")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            We, along with certain third parties, may use other kinds of local storage technologies, such as Local Shared Objects (also referred to as “Flash cookies”) and HTML5 local storage, in connection with our Business Services. These technologies are similar to the cookies discussed above in that they are stored on your device and can be used to store certain information about your activities and preferences. However, these technologies may make use of different parts of your device from standard cookies, and so you might not be able to control them using standard browser tools and settings. For information about disabling or deleting information contained in Flash cookies, please click here.\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("Beacons")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            We, along with certain third parties, also may use technologies called beacons (or “pixels”) that communicate information from your device to a server. Beacons can be embedded in online content, videos, and emails, and can allow a server to read certain types of information from your device, know when you have viewed particular content or a particular email message, determine the time and date on which you viewed the beacon, and the IP address of your device. We and certain third parties use beacons for a variety of purposes, including to analyze the use of our Business Services and (in conjunction with cookies) to provide content and ads that are more relevant to you.\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("Your Choices")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            You can make choices about whether to receive promotional communications from us by following the subscribe options made available at the interactive customized services platform and the unsubscribe instructions included in every communication sent by us.\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("Specific Uses of Personal Information")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            In addition to what has been explained above, we wish to highlight the following specific information practices in connection with certain specific services:\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("Contact")]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              "\n                            If you have any questions regarding this policy, please contact us at: dataprotection@samsung.com\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n                        You may lodge a complaint with a supervisory authority if you consider that our processing of your personal data infringes applicable law.\n                    "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03c17775", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03c17775","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/common/PrivacyPolicyPopup.vue
// module id = pUUb
// module chunks = 0